import PropTypes from 'prop-types';

import styleSheet from '../styles/teamSelector.module.scss';

import { getImageUrl } from '../../helpers/images';

const styles = styleSheet.locals || {};

/**
 * Component for the selector hero
 *
 * @param {object} props props
 * @param {object} props.selector selector data
 * @param {boolean} props.isVisible - header hero visible, to decrease complexity of main components
 * @returns {Function} <Hero />
 */
function Hero({ selector, isVisible = true }) {
    const heroImg = selector.hero_image_url || selector.hero_external_image_url;

    if (!heroImg || !isVisible) {
        return null;
    }

    const renderHeroImage = () => {
        if (selector.hero_image_url) {
            return (
                <img
                    // eslint-disable-next-line no-magic-numbers
                    src={getImageUrl(selector.hero_image_url, 1784)}
                    alt={selector.hero_image_text || ''}
                    className={styles.teamSelectorHeroImage}
                    part="ts-hero-image"
                    data-testid="hero-image-manual"
                />
            );
        }

        if (selector.hero_external_image_url) {
            return (
                <img
                    src={selector.hero_external_image_url}
                    alt={selector.hero_image_text || ''}
                    className={styles.teamSelectorHeroImage}
                    part="ts-hero-image"
                    data-testid="hero-image-automated"
                />
            );
        }

        return null;
    };

    /* eslint-disable no-magic-numbers */
    return (
        <div
            data-cy="heroLabel"
            className={styles.teamSelectorHero}
            data-testid="hero-image"
        >
            {renderHeroImage()}
        </div>
    );
}

Hero.propTypes = {
    selector: PropTypes.object.isRequired,
    isVisible: PropTypes.bool
};

export default Hero;
